import { DevwareMetaDataService, DwMetaDataRoutingRegistryService, DwPageMenu, DwRoutingInitDecorator, DwSecurityPermissions } from '@devwareapps/devware-cap';
import { AppMetaDataService, AppMetaDataItemNames } from './meta-data/app-meta-data.service';
import { Injectable } from '@angular/core';
import { AppPermissions } from './meta-data/app-permissions.enum';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class DevwareRouteSetupService {

    @DwRoutingInitDecorator()
    setupDynamicRoutes() {
        const md = new AppMetaDataService();
        const dwMd = new DevwareMetaDataService();


        DwMetaDataRoutingRegistryService.addRoutes([
            {
                path: 'project-tools',
                parentName: 'root',
                component: DwPageMenu,
                data: {
                    display: 'Project Tools',
                    iconCssClass: 'fa fa-tasks-alt',
                    routeOrder: 1,
                    excludeFromMainMenu: false,
                }
            },
            {
                path: 'human-resources',
                parentName: 'root',
                component: DwPageMenu,
                data: {
                    display: 'Human Resources',
                    iconCssClass: 'fa fa-users',
                    routeOrder: 2,
                    excludeFromMainMenu: false,
                }
            },
            {
                path: 'financial-tools',
                parentName: 'root',
                component: DwPageMenu,
                data: {
                    display: 'Financial Tools',
                    iconCssClass: 'fa fa-landmark',
                    routeOrder: 3,
                    excludeFromMainMenu: false,
                }
            },
            // {
            //   path: 'user-settings',
            //   parentName: 'home',
            //     component: DwPageMenu,
            //     data: {
            //         display: 'User Settings',
            //         iconCssClass: 'fas fa-user-cog',
            //         routeOrder: 4,
            //         excludeFromMainMenu: false,
            //     }
            // }
        ]);

        //  Add Menu Data modules
     /*    DwMetaDataRoutingRegistryService.addMetaDataRoutes([
            {
                path: 'equipment-requests',
                parentName: 'project-tools',
                metaDataItem: AppMetaDataItemNames.Request,
                printConfigKeyPart : 'request-print',
                //  editMetaDataItem : 'Job',
                data: {
                    display: 'My Equipment Requests',
                  iconCssClass: 'fas fa-forklift wa-orange',
                    excludeFromMainMenu: true,
                    routeOrder: 1,
                    // configKeyPart : 'my-nominations',
                }
            },
            {
              path: 'codevalue',
              parentName: 'data',
              metaDataItem: 'CodeSet',
              // editConfigKeyPart: 'codeValue-edit',
              // printConfigKeyPart : 'request-print',
              //  editMetaDataItem : 'Job',
              data: {
                  display: 'Code Values',
                  iconCssClass: 'fa fa-tools',
                  excludeFromMainMenu: true,
                  routeOrder: 1,
                  // canAccessPermission: AppPermissions.CodeValueCanManage,
                  requireAuthentication: true,
                  // configKeyPart : 'my-nominations',
              }
          },
            {
              path: 'licenses-certs',
              parentName: 'project-tools',
              metaDataItem: 'Licenses',
              printConfigKeyPart : 'request-print',
              //  editMetaDataItem : 'Job',
              data: {
                  display: 'Licenses and Certifications',
                iconCssClass: 'fas fa-file-certificate wa-blue',
                  excludeFromMainMenu: true,
                  routeOrder: 2,
                  // configKeyPart : 'my-nominations',
              }
        }, {
          path: 'paf-term',
          parentName: 'human-resources',
          metaDataItem: 'TermResign',
          printConfigKeyPart : 'request-print',
          //  editMetaDataItem : 'Job',
          data: {
              display: 'PAF Term / Resign',
            iconCssClass: 'fas fa-door-open wa-red',
              excludeFromMainMenu: true,
              routeOrder: 2,
              // configKeyPart : 'my-nominations',
          }
        }, {
          path: 'paf-pay-job-change',
          parentName: 'human-resources',
          metaDataItem: 'PayJobChange',
          printConfigKeyPart : 'request-print',
          //  editMetaDataItem : 'Job',
          data: {
              display: 'PAF Pay / Job Change',
            iconCssClass: 'fas fa-money-bill-wave',
              excludeFromMainMenu: true,
              routeOrder: 1,
              // configKeyPart : 'my-nominations',
          }
        }, {
          path: 'kickoff',
          parentName: 'project-tools',
          metaDataItem: 'Kickoff',
          printConfigKeyPart : 'kickoff-print',
          //  editMetaDataItem : 'Job',
          data: {
              display: 'Kickoff Document',
              iconCssClass: 'fa fa-tools',
              excludeFromMainMenu: true,
              routeOrder: 3,
              // configKeyPart : 'my-nominations',
          }
        },
        // TODO - Remove afte wizard testing
         {
          path: 'kickoff-wizard',
          parentName: 'project-tools',
          metaDataItem: 'Kickoff',
          printConfigKeyPart : 'kickoff-print',
          addConfigKeyPart : 'kickoff-wizard',
          data: {
              display: 'Kickoff Document (With Wizard)',
              iconCssClass: 'fa fa-tools',
              excludeFromMainMenu: true,
              routeOrder: 4,
              // configKeyPart : 'my-nominations',
          }
        },
        {
          path: 'mor',
          parentName: 'human-resources',
          metaDataItem: 'MemoOfRecord',
          printConfigKeyPart : 'MemoOfRecord-print',
          //  editMetaDataItem : 'Job',
          data: {
              display: 'Memo Of Record',
              iconCssClass: 'far fa-sticky-note wa-blue',
              excludeFromMainMenu: true,
              routeOrder: 3,
              // configKeyPart : 'my-nominations',
          }
        },
        {
          path: 'etn',
          parentName: 'human-resources',
          metaDataItem: 'EmployeeTrainingNeeded',
          printConfigKeyPart : 'EmployeeTrainingNeeded-print',
          //  editMetaDataItem : 'Job',
          data: {
              display: 'Employee Training Needed',
              iconCssClass: 'fas fa-comments wa-blue',
              excludeFromMainMenu: true,
              routeOrder: 4,
              // configKeyPart : 'my-nominations',
          }
        },
      ]
        ); */
    }
}
